import { IFileDesc } from '@app-types/websocket/file.types';
import WebSocketClient from '@clients/web-socket.client';
import { createUploadRequestId } from './upload.errors';


export function requestFileUpload(data: IFileDesc) {
  const socket = WebSocketClient.getInstance();

    try {
      socket.sendJSON({
        requestId: data.internalId ? createUploadRequestId(Number(data.internalId)) : undefined,
        newUpload: data 
      });
    } catch (error) {
      console.log("file.websocket: error requesting upload slot", error);
    }

}



// WEBPACK FOOTER //
// ./src/services/file/file.websocket.ts